import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {

  @Input() color: string;

  /**
   * Set the default color (Eurosport red)
   */
  constructor() {
    // Set default color
    this.color = '#d50032';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/spinner/spinner.component.ts